import { arrIDSingle } from './languageMapping';
import languageJSON from './languages.json';

var portal = "admin center";

Window.loadLanguage = function (languageName, ttype) {
  if (languageName != '') {
    //alert("function called");
    if (Window.isLanguage()) {
      var filteredData = languageJSON.filter(function (entry) {
        return entry.Language === languageName && entry.Portal === portal;
      });

      if (filteredData.length > 0) {


        Window.IDSingle(filteredData);
        Window.setPlaceHolder(filteredData);
        Window.setToolTip(filteredData);
        Window.NameSingle(filteredData);
        Window.NameMulti(filteredData);
        Window.NameDropDown(filteredData);
        Window.NameMenu(filteredData);


        let filteredValue = '';

        try {

          const accountStatus = document.getElementById("account_status");
          if (accountStatus) {
            // Determine account type and filter data accordingly
            switch (accountStatus.innerHTML) {
              case "Pool Administrator":
                filteredValue = Window.filterJSON(filteredData, "pool_admin");
                break;
              case "Group Administrator":
                filteredValue = Window.filterJSON(filteredData, "group_admin");
                break;
              case "Org Administrator":
                filteredValue = Window.filterJSON(filteredData, "org_admin");
                break;
              case "Data Viewer":
                filteredValue = Window.filterJSON(filteredData, "data_viewer_menu");
                break;
            }

            // Update account status if filtered value exists
            if (filteredValue.length > 0) {
              accountStatus.innerHTML = filteredValue[0].Value;
            }

            // Populate dropdown with filtered data
            Window.DDLSelect(filteredData, "ddlGroupTag");
          }
        } catch (error) {
          console.error("Error processing account status:", error);
        }

        try {
          const dialogBoxes = document.getElementsByClassName("window");
          if (dialogBoxes.length > 0) {
            const dialogBox = dialogBoxes[0];

            // Update confirmation message
            filteredValue = Window.filterJSON(filteredData, "confirm");
            if (filteredValue.length > 0) {
              dialogBox.childNodes[0].innerHTML = filteredValue[0].Value;
            }

            // Update "already logged in" message
            filteredValue = Window.filterJSON(filteredData, "you_are_already_logged_in");
            if (filteredValue.length > 0) {
              let txt = dialogBox.childNodes[1].innerHTML;
              const email = extractEmail(txt);
              const updatedMessage = filteredValue[0].Value.replace(/\[.*?\]/, `[${email}]`);
              dialogBox.childNodes[1].innerHTML = updatedMessage;
            }

            // Update button labels
            updateButtonLabels(dialogBox);
          }
        } catch (error) {
          console.error("Error processing dialog box:", error);
        }


        //Translate Report DropDown from Reports Page
        try{          
          const DDLReportOption = document.getElementById("DDLReportOption"); 
          if (DDLReportOption && DDLReportOption.options.length > 0) {
            for (let i = 0; i < DDLReportOption.options.length; i++) {
              //console.log(DDLReportOption.options[i].text); // prints option text
              DDLReportOption.options[i].innerHTML = Window.getTranslatedText(DDLReportOption.options[i].text);
            }
          }         
        }
        catch(error)
        {
          console.error("Error processing DDLReportOption:", error);
        }



        try{         
          const bannerMessage = document.getElementById("bannerMessage"); // Update Banner Text
          if (bannerMessage)
          {
            bannerMessage.innerText = Window.getTranslatedText(bannerMessage.innerText);
          }         
        }
        catch(error)
        {
          console.error("Error processing bannerMessage:", error);
        }
       

        try {
          const tblPoolMembers = document.getElementById("tblPoolMembers");
          if (tblPoolMembers != null) {
            const btn_tblPoolMembers = tblPoolMembers.getElementsByTagName("button");           
            if (btn_tblPoolMembers.length > 0) {
              updateFilterButtons(tblPoolMembers);

              // Update dropdowns
              const dropdowns = [
                "verified", "disabled", "privileges", "groups", "bundles", "products", "trainingPlans"
              ];
              dropdowns.forEach(id => {
                const ddl = document.getElementById(`ddl${capitalizeFirstLetter(id)}`);
                Window.DropDownLanguage(filteredData, ddl, id);
              });

              const ddlMembersOptions = tblPoolMembers.getElementsByTagName("select");
              if (ddlMembersOptions.length > 0) {
                Window.DropDownLanguage(filteredData, ddlMembersOptions[0], "main");
              }

              // Update pagination
              updatePagination(tblPoolMembers);
             
            }
          }
        } catch (error) {
          console.error("Error processing pool members:", error);
        }

        // Function to extract email from a string
        function extractEmail(text) {
          const init = text.indexOf('[');
          const fin = text.indexOf(']');
          return text.substr(init + 1, fin - init - 1);
        }

        // Function to update button labels
        function updateButtonLabels(dialogBox) {
          const cancelBtn = document.getElementsByClassName("cancel-btn");
          const okBtn = document.getElementsByClassName("ok-btn");

          let filteredValue = Window.filterJSON(filteredData, "continue");
          if (filteredValue.length > 0 && cancelBtn.length > 0) {
            cancelBtn[0].innerHTML = filteredValue[0].Value;
          }

          filteredValue = Window.filterJSON(filteredData, "log_out");
          if (filteredValue.length > 0 && okBtn.length > 0) {
            okBtn[0].innerHTML = filteredValue[0].Value;
          }
        }

        // Function to update filter buttons in the pool members table
        function updateFilterButtons(tblPoolMembers) {
          const filterButtons = tblPoolMembers.getElementsByClassName('btn btn-secondary smallheight nopadding');

          for (let button of filterButtons) {
            const buttonTextMap = {
              "Add/Invite": "add_invite",
              "Send Message": "send_message",
              "Refresh User List": "refresh_user_list"
            };

            if (buttonTextMap[button.innerHTML]) {
              let filteredValue = Window.filterJSON(filteredData, buttonTextMap[button.innerHTML]);
              if (filteredValue.length > 0) {
                button.innerHTML = filteredValue[0].Value;
                if (button.innerHTML.includes("Refresh User List") || button.innerHTML.includes("Refrescar lista de miembros")) {
                  button.classList.remove("btn-short");
                  button.style.width = "255px"; // set width for this specific button
                }
              }
            }
          }
        }

        // Function to update pagination
        function updatePagination(tblPoolMembers) {
          const prev = tblPoolMembers.querySelector(".text-right a:nth-child(1)");
          const next = tblPoolMembers.querySelector(".text-right a:nth-child(2)");

          if (prev) {
            filteredValue = Window.filterJSON(filteredData, "previous");
            if (filteredValue.length > 0) {
              prev.innerHTML = filteredValue[0].Value;
            }
          }

          if (next) {
            filteredValue = Window.filterJSON(filteredData, "next");
            if (filteredValue.length > 0) {
              next.innerHTML = filteredValue[0].Value;
            }
          }

          const footerPage = tblPoolMembers.querySelector(".wtTopBorder").getElementsByTagName("a");
          if (footerPage.length > 0) {
            updateFooterLinks(footerPage);
          }
        }

        // Function to update footer links
        function updateFooterLinks(footerPage) {
          const linkNames = ["previous", "next", "show_all"];

          linkNames.forEach((name, index) => {
            const link = footerPage[index];
            if (link) {
              filteredValue = Window.filterJSON(filteredData, name);
              if (filteredValue.length > 0) {
                link.innerHTML = filteredValue[0].Value;
              }
            }
          });
        }

        function updateTableNoRecord(container, selector, filterKey) {         
          const elements = container.querySelectorAll(selector);
          if (elements.length > 0) {
            const filteredValue = Window.filterJSON(filteredData, filterKey);
            if (filteredValue && filteredValue.length > 0) {
              if (elements[0].innerText.includes(" no ") || elements[0].innerText.includes("No"))//if text match
              {
                elements[0].innerText = filteredValue[0].Value;
              }
            }
          }
        }
       

        // Function to capitalize the first letter of a string
        function capitalizeFirstLetter(string) {
          return string.charAt(0).toUpperCase() + string.slice(1);
        }


        // Utility function to update innerHTML if element and value exist
        function updateInnerHTML(element, value) {
          if (element && value.length > 0) {
            element.innerHTML = value[0].Value;
          }
        }

        // Function to handle individual modal elements
        function handleModalElements(elementId, dataKey, isButtonArray = false, buttonIndex = 0) {
          const element = document.getElementById(elementId);
          if (element) {
            const filteredValue = Window.filterJSON(filteredData, dataKey);
            if (isButtonArray) {
              const buttons = element.getElementsByTagName("button");
              if (buttons.length > buttonIndex) {
                updateInnerHTML(buttons[buttonIndex], filteredValue);
              }
            } else {
              updateInnerHTML(element, filteredValue);
            }
          }
        }

          // Function to handle bold elements in table settings body
          function handleBoldElements(tableSettingsBody) {
            const boldElements = tableSettingsBody.getElementsByTagName("b");
            const dataKeys = {
              "Member": "member",
              "Status": "status",
              "Last Login": "last_login",             
              "Disabled": "disabled",
              "Pool Privileges": "pool_privileges",
              "Group Privileges": "group_privileges",
              "Privilege": "privilege",
              "Edit": "edit",
              "Product Name": "product_name",
              "# Left": "hash_left",
              "Term": "term",
              "# Members": "hash_members",
              "Members": "members",
              "Details": "details",
              "Score": "score",
              "Transcript": "transcript",
              "# Turns": "hashtag_turns",
              "Product Name": "product_name",
              "Date Started": "date_started",
              "Priviledges":"priviledges"
            };
           
            for (let b of boldElements) {
              for (const [key, value] of Object.entries(dataKeys)) {
                if (b.innerHTML.includes(key)) {
                  const filteredValue = Window.filterJSON(filteredData, value);
                  if (filteredValue) {
                b.innerHTML = filteredValue[0].Value;
              }
              break;
            }
          }
        }
      }

      // Function to handle footer elements       

      try {
        const tableSettingsTitle = document.getElementById("tableSettings___BV_modal_title_");
        if (tableSettingsTitle) {
          updateInnerHTML(tableSettingsTitle, Window.filterJSON(filteredData, "table_settings"));

          const tableSettingsBody = document.getElementById("tableSettings___BV_modal_body_");
          if (tableSettingsBody) {
            updateInnerHTML(document.getElementById("columns_shown"), Window.filterJSON(filteredData, "columns_shown"));
            updateInnerHTML(document.getElementById("columns_not_shown"), Window.filterJSON(filteredData, "columns_not_shown"));

            updateInnerHTML(document.getElementById("columns_reordered"), Window.filterJSON(filteredData, "columns_reordered"));

            const addColumn = Window.filterJSON(filteredData, "add_column");
            const restoreDefault = Window.filterJSON(filteredData, "restore_defaults");
            updateInnerHTML(document.getElementById("add_column"), addColumn);
            updateInnerHTML(document.getElementById("restore_default"), restoreDefault);


            //handleBoldElements(tableSettingsBody);

            ////dropdown
            //debugger;          
            //// Find the first <select> element inside the modal
            //const ddlColumnAdd = document.getElementById("ddlColumnAdd");
            //if (ddlColumnAdd) {
            //  // Loop through all options in the dropdown
            //  ddlColumnAdd.querySelectorAll("option").forEach(option => {              

            //    option.innerHTML=Window.getTranslatedText(option.textContent.trim());

            //  });
            //} else {
            //  console.log("Dropdown not found!");
            //}


          }

          handleModalElements("tableSettings___BV_modal_footer_", "ok", true, 0);
        }
      } catch (e) {
        console.error(e);
      }

      try {
        handleFooterElements("edit_privileges___BV_modal_footer_", "cancel", "ok");
      } catch (e) {
        console.error(e);
      }

      try {
        handleModalElements("reset_table_setting___BV_modal_title_", "reset_table_setting");
        handleModalElements("reset_table_setting___BV_modal_body_", "reset_table_setting_body");

        const resetTableSettingFooter = document.getElementById("reset_table_setting___BV_modal_footer_");
        if (resetTableSettingFooter) {
          const no = Window.filterJSON(filteredData, "no");
          const yes = Window.filterJSON(filteredData, "yes");

          updateInnerHTML(resetTableSettingFooter.getElementsByTagName("button")[0], no);
          updateInnerHTML(resetTableSettingFooter.getElementsByTagName("button")[1], yes);
        }
      } catch (e) {
        console.error(e);
      }

      try {
        const filterByProduct = document.getElementById("filter_by_product");
        if (filterByProduct) {
          Window.DropDownLanguage(filteredData, filterByProduct, "md_products");
        }

        const filterByTrainingPlan = document.getElementById("filter_by_training_plan");
        if (filterByTrainingPlan) {
          Window.DropDownLanguage(filteredData, filterByTrainingPlan, "md_training_plan");
        }
      } catch (e) {
        console.error(e);
      }

      try {        
        if (ttype != null && typeof (ttype) !== "undefined") {
         
          const assignNoAvailable = document.getElementById("assign_no_available");

          const ttypeMap = {
            "Groups": "groups",
            "Products": "products",
            "Bundles": "bundles",
            "Training Plans": "training_plans"
          };

          const assignType = document.getElementsByName("ttype");
          const ttypeValue = Window.filterJSON(filteredData, ttypeMap[ttype]);

          if (assignType.length > 0 && ttypeValue.length > 0) {
            assignType.forEach((element, index) => {
              element.innerHTML = ttypeValue[0].Value; // Assigning value to each element             
            });
          } 

          if (assignNoAvailable && ttypeValue) {
            assignNoAvailable.innerHTML = assignNoAvailable.innerHTML.replace(/\[(.*?)\]/g, ttypeValue[0].Value);
          }
        }
      } catch (e) {
        console.error(e);
      }

      try {
        const groupList = document.getElementById("group_list");
        if (groupList) {
          const ddlGroupOptions = groupList.getElementsByTagName("select");
          if (ddlGroupOptions.length > 0) {
            Window.DropDownLanguage(filteredData, ddlGroupOptions[0], "group_option");
            Window.DropDownLanguage(filteredData, ddlGroupOptions[1], "group_assign");
          }

        
          //Update text "No record found"
          updateTableNoRecord(groupList, "div.pp5", "no_subgroups");
        }

        handleFooterElements("add_group___BV_modal_footer_", "cancel", "ok");
        handleFooterElements("mass_add_group___BV_modal_footer_", "cancel", "ok");

        if (document.getElementById("group_delete_confirm")) {
          handleFooterElements("group_delete_confirm___BV_modal_footer_", "no", "yes");

          handleModalElements("group_delete_confirm___BV_modal_title_", "confirm_delete");
          handleModalElements("group_delete_confirm___BV_modal_body_", "group_delete_confirmation");
        }

        handleModalElements("save", "save");
      } catch (e) {
        console.error(e);
      }

      try {
        const tblPrivileges = document.getElementById("tblPrivileges");
        if (tblPrivileges) {

          const divs = tblPrivileges.querySelectorAll("div"); // Get all divs inside tblPrivileges

          divs.forEach(div => {
            if (div.innerText.includes("Has No Privileged Members")) {
               
              div.innerText = Window.getTranslatedText(div.innerText);

            }
          });
         

         
          const filterButtons = tblPrivileges.getElementsByClassName('btn btn-secondary smallheight nopadding');
          for (let button of filterButtons) {
            if (button.innerHTML == "Add +") {
              updateInnerHTML(button, Window.filterJSON(filteredData, "add_plus"));
            }
          }

          const prev = tblPrivileges.getElementsByClassName("text-right")[0].getElementsByTagName("a")[0];
          const next = tblPrivileges.getElementsByClassName("text-right")[0].getElementsByTagName("a")[1];
          updateInnerHTML(prev, Window.filterJSON(filteredData, "previous"));
          updateInnerHTML(next, Window.filterJSON(filteredData, "next"));

          const tableHeaders = tblPrivileges.getElementsByTagName("th");
          const headerMap = {
            "Member": "member",
            "Pool Privileges": "pool_privileges",
            "Group Privileges": "group_privileges",
            "Edit": "edit"
          };

          for (let th of tableHeaders) {
            const thText = th.getElementsByTagName("button")[0];
            for (const [key, value] of Object.entries(headerMap)) {
              if (thText.innerHTML.includes(key)) {
                const filteredValue = Window.filterJSON(filteredData, value);
                if (thText.innerHTML.includes("Editar")) {
              thText.innerHTML = thText.innerHTML.replace("Editar", filteredValue[0].Value);
            } else {
                  thText.innerHTML = thText.innerHTML.replace(key, filteredValue[0].Value);
          }

          break;
        }
      }
    }
  }
} catch (e) {
  console.error(e);
}

try {
  const tableTitle = document.getElementById("tableTitle");
  if (tableTitle) {
    const titleMap = {
      "Pool Members": "pool_members",
      "Group Members": "group_members",
      "Privileged Members": "privilege_members",
      "Groups": "groups",
      "Subgroups": "subgroups",
      "Pool Products": "pool_products",
      "Transcript Results": "transcript_results"
    };

    const filteredValue = Window.filterJSON(filteredData, titleMap[tableTitle.innerHTML]);
    updateInnerHTML(tableTitle, filteredValue);
  }
} catch (e) {
  console.error(e);
}



/*============================================PRODUCTS START============================================*/


// Function to handle modal footer elements
function handleFooterElements(footerId, cancelKey, okKey) {
  const footer = document.getElementById(footerId);
  if (footer) {

    const buttons = footer.getElementsByTagName("button");
    if (buttons.length > 1) {
      const cancel = Window.filterJSON(filteredData, cancelKey);
      updateInnerHTML(buttons[0], cancel);

      const ok = Window.filterJSON(filteredData, okKey);
      updateInnerHTML(buttons[1], ok);
    }
    else if (buttons.length > 0) {

      const ok = Window.filterJSON(filteredData, okKey);
      updateInnerHTML(buttons[0], ok);
    }
  }
}


// Update previous and next buttons
function updatePrevNextButtons(container, prevKey, nextKey) {
  const prev = container.getElementsByClassName("text-right")[0].getElementsByTagName("a")[0];
  const next = container.getElementsByClassName("text-right")[0].getElementsByTagName("a")[1];
  if (prev) {
    updateInnerHTML(prev, Window.filterJSON(filteredData, prevKey));
  }
  if (next) {
    updateInnerHTML(next, Window.filterJSON(filteredData, nextKey));
  }
}

// Handle product table updates
try {
  const tblProducts = document.getElementById("tblProducts");
  if (tblProducts) {
    const btnTblProducts = tblProducts.getElementsByTagName("button");
    if (btnTblProducts.length > 0) {
      updatePrevNextButtons(tblProducts, "previous", "next");
    
    }

    const ddlProductsOptions = tblProducts.getElementsByTagName("select");
    if (ddlProductsOptions.length > 0) {
      Window.DropDownLanguage(filteredData, ddlProductsOptions[0], "products_option");
    }
  }
} catch (e) {
  console.error(e);
}

// Handle add free licenses modal
try {
  const addFreeLicensesTitle = document.getElementById("add_free_licenses___BV_modal_title_");
  if (addFreeLicensesTitle) {
    updateInnerHTML(addFreeLicensesTitle, Window.filterJSON(filteredData, "add_free_licenses"));
  }

  handleFooterElements("add_free_licenses___BV_modal_footer_", "cancel", "ok");
} catch (e) {
  console.error(e);
}

// Handle confirm add trial licenses modal
try {
  const confirmAddTrialLicensesTitle = document.getElementById("confirm_add_trial_licenses___BV_modal_title_");
  if (confirmAddTrialLicensesTitle) {
    updateInnerHTML(confirmAddTrialLicensesTitle, Window.filterJSON(filteredData, "confirm_add_trial_licenses"));
  }

  const confirmAddTrialLicensesBody = document.getElementById("confirm_add_trial_licenses___BV_modal_body_");
  if (confirmAddTrialLicensesBody) {
    updateInnerHTML(confirmAddTrialLicensesBody, Window.filterJSON(filteredData, "confirm_add_trial_licenses_message"));
  }

  handleFooterElements("confirm_add_trial_licenses___BV_modal_footer_", "no", "yes");
} catch (e) {
  console.error(e);
}

// members modal
try {
  const membersModelTitle = document.getElementById("members_model___BV_modal_title_");
  if (membersModelTitle) {
    updateInnerHTML(membersModelTitle, Window.filterJSON(filteredData, "members"));
  }

  handleFooterElements("members_model___BV_modal_footer_", "ok", "ok");
} catch (e) {
  console.error(e);
}


// Products modal
try {
  const productsModelTitle = document.getElementById("products_model___BV_modal_title_");
  if (productsModelTitle) {
    updateInnerHTML(productsModelTitle, Window.filterJSON(filteredData, "product_details"));
  }

  handleFooterElements("products_model___BV_modal_footer_", "ok", "ok");
} catch (e) {
  console.error(e);
}


// select products modal
try {
  const lProductsModelTitle = document.getElementById("lProducts___BV_modal_title_");
  if (lProductsModelTitle) {
    updateInnerHTML(lProductsModelTitle, Window.filterJSON(filteredData, "select_products"));
  }

  handleFooterElements("lProducts___BV_modal_footer_", "cancel", "ok");
} catch (e) {
  console.error(e);
}


// custom timeframe modal
try {
  const customTimeframeModelTitle = document.getElementById("customTimeframe___BV_modal_title_");
  if (customTimeframeModelTitle) {
    updateInnerHTML(customTimeframeModelTitle, Window.filterJSON(filteredData, "custom_timeframe"));
  }

  handleFooterElements("customTimeframe___BV_modal_footer_", "cancel", "ok");
} catch (e) {
  console.error(e);
}

// select groups modal
try {
  const lGroupsModelTitle = document.getElementById("lGroups___BV_modal_title_");
  if (lGroupsModelTitle) {
    updateInnerHTML(lGroupsModelTitle, Window.filterJSON(filteredData, "select_groups"));
  }

  handleFooterElements("lGroups___BV_modal_footer_", "cancel", "ok");
} catch (e) {
  console.error(e);
}

// select Model Filter By Date
try {
  const ModelFilterByDateTitle = document.getElementById("ModelFilterByDate___BV_modal_title_");
  if (ModelFilterByDateTitle) {
    updateInnerHTML(ModelFilterByDateTitle, Window.filterJSON(filteredData, "select_date_range"));
  }

  handleFooterElements("ModelFilterByDate___BV_modal_footer_", "cancel", "ok");
} catch (e) {
  console.error(e);
}

// select Model Remove model 
try {

  const modalElement = document.querySelector('.remove_item_model');

  if (modalElement) {

    const ModelRemoveGroupTitle = document.getElementById(modalElement.id+"___BV_modal_title_");

    if (ModelRemoveGroupTitle) {
      updateInnerHTML(ModelRemoveGroupTitle, Window.filterJSON(filteredData, "confirm_removal"));
    }

    const ModelRemoveGroupBody = document.getElementById(modalElement.id+"___BV_modal_body_");
    
    if (ModelRemoveGroupBody) {
      const textMap = {       
        "product": "are_you_sure_remove_product",
        "bundle": "are_you_sure_remove_bundle",
        "training plan": "are_you_sure_remove_training_plan",
        "group tag": "popup_delete_tag",
        "group": "are_you_sure_remove_group"
      };

      for (const [key, value] of Object.entries(textMap)) {
          if (ModelRemoveGroupBody.innerText.toLowerCase().includes(key)) {
              updateInnerHTML(ModelRemoveGroupBody, Window.filterJSON(filteredData, value));
              break;
      }
  }
}


handleFooterElements(modalElement.id+"___BV_modal_footer_", "cancel", "delete");
} 

 
} catch (e) {
  console.error(e);
}


//// select Delete confirm model
//try {
//  debugger;

//  const modalElement2 = document.querySelector('.delete_confirm_model');

//  if (modalElement2) {

//    const ModelRemoveTitle = document.getElementById(modalElement2.id+"___BV_modal_title_");

//    if (ModelRemoveTitle) {
//      updateInnerHTML(ModelRemoveTitle, Window.filterJSON(filteredData, "confirm_delete"));
//    }

//    const ModelRemoveBody = document.getElementById(modalElement2.id+"___BV_modal_body_");

//    if (ModelRemoveBody) {
//      updateInnerHTML(ModelRemoveBody, Window.filterJSON(filteredData, "popup_delete_tag"));
//    }

//    handleFooterElements(modalElement2.id+"___BV_modal_footer_", "cancel", "delete");
//  } 

 
//} catch (e) {
//  console.error(e);
//}



// Handle dropdown options for reports and bundles
try {


  function updateDropdowns(filteredData) {
    // List of dropdowns and their corresponding keys in the filteredData object
    const dropdowns = [
      //{ id: 'DDLReportOption', key: 'reporting_option' },
      { id: 'ddlCharacter', key: 'ddlcharacter' },
      { id: 'ddlScore', key: 'score' },
      { id: 'ddlNumberOfTurns', key: 'number_of_turns' }, // Fixed typo: 'ddlNummberOfTurns' to 'ddlNumberOfTurns'
      { id: 'ddlELearningTime', key: 'e_learning_time' },
      { id: 'ddlSimulationTime', key: 'simulation_time' },
      { id: 'ddlStartDate', key: 'start_date' },
      { id: 'ddlFinishDate', key: 'finish_date' },
      { id: 'ddlGroupParent', key: 'group_parent' },
      { id: 'ddlGroupParent2', key: 'group_parent' }
    ];

    dropdowns.forEach(({ id, key }) => {
      const element = document.getElementById(id);
      if (element) {
        try {
          Window.DropDownLanguage(filteredData, element, key);
        } catch (error) {
          console.error(`Failed to update dropdown with id '${id}' using key '${key}':`, error);
        }
      } else {
        console.warn(`Dropdown with id '${id}' not found.`);
      }
    });
  }

  // Example usage
  updateDropdowns(filteredData);


  Window.DDLSelect(filteredData, "ddlBundle");
  Window.DDLSelect(filteredData, "ddlProduct");
  Window.DDLSelect(filteredData, "ddlSavedSearch");
  Window.DDLSelect(filteredData, "ddlCreateReport");

  Window.DDLSelect(filteredData, "ddlPrivilegesFor");
  var dropdown = document.getElementById('ddlPrivilegesFor');
  if (dropdown && dropdown.options.length > 0) {
    dropdown.selectedIndex = 0;
  }

  Window.DDLSelect(filteredData, "ddlPrivilegeGroup");
  Window.DDLSelect(filteredData, "ddlPrivilegeGroup2");
         

  handleFooterElements("modalCompleteTASchedule___BV_modal_footer_", "cancel", "ok");
  handleFooterElements("modalSavedSearch___BV_modal_footer_", "cancel", "ok");


} catch (e) {
  console.error(e);
}

try {
  const tblTranscriptResult = document.getElementById("tblTranscriptResult");
  if (tblTranscriptResult != null) {
    const btn_tblTranscriptResult = tblTranscriptResult.getElementsByTagName("button");
    if (btn_tblTranscriptResult.length > 0) {
      updateFilterButtons(tblTranscriptResult);

      // Update pagination
      updatePagination(tblTranscriptResult);

      //Update text "No record found"
      updateTableNoRecord(tblTranscriptResult, "div.mt-2", "no_record_found");

    }

   

  }
} catch (error) {
  console.error("Error processing pool members:", error);
}



try {
  Window.readAndChangeColumnText('#tblPoolMembers', 1);
  Window.readAndChangeColumnText('#tblPoolMembers', 3);
  Window.readAndChangeColumnText('#tblPoolMembers', 4);
} catch (error) {
  console.error("Error translating members column text:", error);
}
       
try {
  const arrTimelineActivities = [
    "client_verified_account","user_logged_in_portal", "user_logged_out", "added_client_product_for_client",
    "finished_play_of", "started_play_of", "lop", "score", "language","level_of_play","password_was_changed_for_user",
    "removed_client_product_for_client", "added_user_busters_to", "added_member_to_group", "added_user_with_email", "edited_client", "sent_invite_confirmation_to", "and_product",
    "started_questionnaire", "removed_member","from_group","added_member","to_group","added_user","changed_client"
  ];
  
  const filteredDataEnglish = languageJSON.filter(entry => entry.Language === "English" && entry.Portal === portal);

  // Function to replace text in elements
  function replaceTextInElements(elementName, key, filteredValue, filteredValue2) {
    document.getElementsByName(elementName).forEach(element => {
      if (!element || !filteredValue2?.[0]?.Value || !filteredValue?.[0]?.Value) return;
     
      const originalText = element.innerText.trim();
      if (originalText.includes(filteredValue2[0].Value)) {
        element.innerHTML = originalText.replace(filteredValue2[0].Value, filteredValue[0].Value);
      }
    });
  }

  arrTimelineActivities.forEach(key => {
   
    const filteredValue = Window.filterJSON(filteredData, key); // Español
    const filteredValue2 = Window.filterJSON(filteredDataEnglish, key); // English

    replaceTextInElements("timeline_activity_text", key, filteredValue, filteredValue2);
    replaceTextInElements("timeline_activity_score", key, filteredValue, filteredValue2);

    // Process Date elements
    document.getElementsByName("timeline_activity_date").forEach(element => {
      if (!element) return;

      const dateStr = element.innerHTML.trim();
      const dateObj = new Date(dateStr);
      if (!isNaN(dateObj)) {
        element.innerHTML = new Intl.DateTimeFormat('es-ES', { day: 'numeric', month: 'long', year: 'numeric' }).format(dateObj);
      }
    });
  });
} catch (e) {
  console.error("Error processing timeline activities:", e);
}


const select_members_or_groups = document.getElementById("select_members_or_groups");
if (select_members_or_groups) {
  if (select_members_or_groups.innerText.includes("Members") || select_members_or_groups.innerText.includes("Miembros")) {
    updateInnerHTML(select_members_or_groups, Window.filterJSON(filteredData, "select_members"));
  } else if (select_members_or_groups.innerText.includes("Groups") || select_members_or_groups.innerText.includes("Grupos")) {
    updateInnerHTML(select_members_or_groups, Window.filterJSON(filteredData, "select_groups"));
  }
}

}
}
}
}

// Function to load language popup based on the given language name
Window.loadLanguagePopup = function (languageName) {
  if (languageName !== '') {
    if (Window.isLanguage()) {
      const filteredData = languageJSON.filter(entry => entry.Language === "English" && entry.Portal === portal);
      const filteredData2 = languageJSON.filter(entry => entry.Language === languageName && entry.Portal === portal);

      if (filteredData.length > 0 && filteredData2.length > 0) {
        Window.Popup(filteredData, filteredData2);
      }
    }
  }
};

// Function to load language and return the text translation based on the given language name
Window.getTranslatedText = function (text) {
  const languageName = sessionStorage.getItem("userLanguage");
    
  // If no language is set or translation is not enabled, return original text
  if (!languageName || !Window.isLanguage()) return text;

  // Get English and target language data for the current portal
  const englishData = languageJSON.filter(entry => entry.Language === "English" && entry.Portal === portal);
  const targetData = languageJSON.filter(entry => entry.Language === languageName && entry.Portal === portal);
    
  // If no data is found, return original text
  if (!englishData.length || !targetData.length) return text;

  // Find the key for the given text in English data
  const englishEntry = Window.filterJSONvalue(englishData, text)?.[0];
  if (!englishEntry) return text;

  // Get the translated value using the key
  const translatedEntry = Window.filterJSON(targetData, englishEntry.Key)?.[0];
    
  // Return the translated text if found, otherwise return the original text
  return translatedEntry ? translatedEntry.Value : text;
};


// Function to load language content based on the type and popup parameters
Window.loadLanguageContent = function (ttype, popup) {
  let ClientID = '';

  const udata = JSON.parse(localStorage.getItem("udata"));
  if (udata) {
    ClientID = udata.ClientID;
  }

  const hostname = window.location.origin.includes("admin.simmersion.com")
    ? "https://tcapi.simmersion.net"
    : "https://tcapi.simmersionstage.net";

  const url = `${hostname}/SSO.svc/GetLanguageByClientID?ClientID=${ClientID}`;

  const xhr = new XMLHttpRequest();
  xhr.open("GET", url, true);

  xhr.onreadystatechange = function () {
    if (this.readyState === 4 && this.status === 200) {
      const responseText = this.responseText.replace('<string xmlns="http://schemas.microsoft.com/2003/10/Serialization/">', '').replace('</string>', '');
      const [languageName, languageID] = responseText.split('@@@');

      sessionStorage.setItem("userLanguage", languageName);
      sessionStorage.setItem("userLanguageID", languageID);

      Window.loadLanguage(languageName, ttype);

      if (popup) {
        Window.loadLanguagePopup(languageName);
      }
    } else {
      // Handle the error case if necessary
      // window.alert("Error occurred while fetching user information from TCAPI.");
    }
  };

  xhr.send();
};

// Function to check if the language should be loaded based on Language Portal conditions
Window.isLanguage = function () {
  let isLoad = false;

  const languagePortalData = sessionStorage.getItem("LanguagePortal");
  if (languagePortalData) {
    const LanguagePortal = JSON.parse(languagePortalData);
    const userLanguageID = sessionStorage.getItem("userLanguageID");

    const environment = window.location.origin.includes("admin.simmersion.com") ? "Production" : "Stage";

    for (const portalEntry of LanguagePortal) {
      if (portalEntry.LanguageID === userLanguageID && portalEntry.DisplayToUser.includes(environment)) {
        isLoad = true;
        break;
      }
    }
  }

  return isLoad;
};


